import { table } from './_table';

export const templates = {
  namespaced: true,
  modules: {
    table
  }
};
